export var Namespace;
(function (Namespace) {
    Namespace["ROOT"] = "root";
    Namespace["VAULT"] = "vault";
})(Namespace || (Namespace = {}));
